export default __webpack_public_path__ + "static/media/blackArrow.0f5c9594.svg";